"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelOr = exports.isNavLinkButton = exports.isIconButton = exports.isTextButton = exports.OverlayTrigger = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const AvatarButton_1 = require("../AvatarButton");
const Button_1 = require("../Button");
const Icon_1 = require("../Icon");
const IconButton_1 = require("../IconButton");
const internal_1 = require("./");
const NavLink_1 = require("../NavLink");
const Css_1 = require("../../Css");
const utils_1 = require("../../utils");
const defaultTestId_1 = require("../../utils/defaultTestId");
function OverlayTrigger(props) {
    var _a, _b, _c;
    const { trigger, buttonRef, menuTriggerProps, placement, state, disabled, tooltip, children, variant, hideEndAdornment, showActiveBorder = false, contrast = false, } = props;
    const popoverRef = (0, react_1.useRef)(null);
    const { overlayProps: positionProps } = (0, react_aria_1.useOverlayPosition)({
        targetRef: buttonRef,
        overlayRef: popoverRef,
        shouldFlip: true,
        isOpen: state.isOpen,
        onClose: state.close,
        placement: (placement ? `bottom ${placement}` : "bottom left"),
        offset: showActiveBorder ? 4 : undefined,
    });
    const tid = (0, utils_1.useTestIds)(props, isTextButton(trigger)
        ? (0, defaultTestId_1.defaultTestId)(labelOr(trigger, "overlayTrigger"))
        : isNavLinkButton(trigger)
            ? (0, defaultTestId_1.defaultTestId)(trigger.navLabel)
            : isIconButton(trigger)
                ? trigger.icon
                : trigger.name);
    return ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.relative.dib.$, children: [isTextButton(trigger) ? ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: variant ? variant : "secondary", contrast: contrast, ...trigger, menuTriggerProps: menuTriggerProps, buttonRef: buttonRef, endAdornment: !hideEndAdornment ? (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: state.isOpen ? "chevronUp" : "chevronDown" }) : null, disabled: disabled, tooltip: tooltip, onClick: (_a = menuTriggerProps.onPress) !== null && _a !== void 0 ? _a : utils_1.noop, forceFocusStyles: showActiveBorder && state.isOpen, ...tid })) : isNavLinkButton(trigger) ? ((0, jsx_runtime_1.jsx)(NavLink_1.NavLink, { ...trigger, label: trigger.navLabel, disabled: !!disabled, contrast: contrast, menuTriggerProps: menuTriggerProps, buttonRef: buttonRef, ...tid })) : isIconButton(trigger) ? ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { ...trigger, menuTriggerProps: menuTriggerProps, buttonRef: buttonRef, ...tid, disabled: disabled, tooltip: tooltip, onClick: (_b = menuTriggerProps.onPress) !== null && _b !== void 0 ? _b : utils_1.noop, forceFocusStyles: showActiveBorder && state.isOpen })) : ((0, jsx_runtime_1.jsx)(AvatarButton_1.AvatarButton, { ...trigger, menuTriggerProps: menuTriggerProps, buttonRef: buttonRef, ...tid, disabled: disabled, tooltip: tooltip, onClick: (_c = menuTriggerProps.onPress) !== null && _c !== void 0 ? _c : utils_1.noop, forceFocusStyles: showActiveBorder && state.isOpen })), state.isOpen && ((0, jsx_runtime_1.jsx)(internal_1.Popover, { triggerRef: buttonRef, popoverRef: popoverRef, positionProps: positionProps, onClose: () => state.close(), isOpen: state.isOpen, children: children }))] }));
}
exports.OverlayTrigger = OverlayTrigger;
function isTextButton(trigger) {
    return trigger && typeof trigger === "object" && "label" in trigger;
}
exports.isTextButton = isTextButton;
function isIconButton(trigger) {
    return trigger && typeof trigger === "object" && "icon" in trigger;
}
exports.isIconButton = isIconButton;
function isNavLinkButton(trigger) {
    return trigger && typeof trigger === "object" && "navLabel" in trigger;
}
exports.isNavLinkButton = isNavLinkButton;
function labelOr(trigger, fallback) {
    return typeof trigger.label === "string" ? trigger.label : fallback;
}
exports.labelOr = labelOr;
